import { colorPalette } from '@sharefiledev/antd-config';
import { Tag, Tooltip } from 'antd';
import { t } from 'utils/translate';

export const BetaTag = () => {
	return (
		<Tooltip title={t('summarization.beta.message')} trigger={['hover', 'focus']}>
			<Tag
				color={colorPalette.neutral13}
				style={{ color: colorPalette.neutral1, cursor: 'pointer' }}
			>
				{t('summarization.beta.title')}
			</Tag>
		</Tooltip>
	);
};
